(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-scratch/assets/javascripts/components/top-bar/components/top-bar-page.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-scratch/assets/javascripts/components/top-bar/components/top-bar-page.js');
"use strict";


const {
  useEffect,
  useRef,
  useState
} = React;
setGlobal('svs.ticketgames.ticketScratch.components.topBar.TopBarPage', _ref => {
  let {
    spelguide,
    order,
    activeOrder
  } = _ref;
  const ref = useRef(null);
  const [animating, setAnimating] = useState(false);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    setAnimating(true);
    gsap.to(ref.current, {
      duration: activeOrder < 0 ? 0.5 : 0.3,
      xPercent: activeOrder * -100,
      onComplete: () => {
        setAnimating(false);
        setVisible(spelguide.active);
      }
    });
  }, [activeOrder]);
  return React.createElement("div", {
    className: "ts-overlay-content ".concat(spelguide.active && ' js-active'),
    "data-id": spelguide.tabName,
    "data-tab": order,
    ref: ref,
    style: {
      visibility: visible || animating ? 'visible' : 'hidden',
      textDecoration: 'none'
    },
    tabIndex: "0"
  }, React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: svs.content.simple_article.templates.simple_article(spelguide)
    }
  }));
});

 })(window);